var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FormControlLabel, RadioGroup, Radio } from '@mui/material';
import Outline from './outline';
import { inject, observer } from 'mobx-react';
var CustomFieldRadio = /** @class */ (function (_super) {
    __extends(CustomFieldRadio, _super);
    function CustomFieldRadio(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.field.value
        };
        return _this;
    }
    Object.defineProperty(CustomFieldRadio.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var options = (_a = this.props.field.options) === null || _a === void 0 ? void 0 : _a.map(function (o, index) {
                var _a;
                return (_jsx(FormControlLabel, { value: o.value, label: (_a = _this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel(o.name, o.value), control: _jsx(Radio, { color: "primary" }, void 0) }, index));
            });
            return (_jsx(Outline, __assign({ label: this.props.label }, { children: _jsx(RadioGroup, __assign({ defaultValue: "top", value: this.props.field.value, onChange: function (e) { return _this.onValueChanged(e); } }, { children: options }), void 0) }), void 0));
        }
    });
    Object.defineProperty(CustomFieldRadio.prototype, "onValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldValue(this.props.field, e.target.value);
        }
    });
    CustomFieldRadio = __decorate([
        inject('fieldsStore'),
        inject('languageStore'),
        observer
    ], CustomFieldRadio);
    return CustomFieldRadio;
}(React.Component));
export default CustomFieldRadio;
